module.exports = __webpack_public_path__ + "img/kr-product-ecmy-card2-img2.68f68af.png";